"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getInitialState = require("./getInitialState");

Object.keys(_getInitialState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getInitialState[key];
    }
  });
});

var _getInitialProps = require("./getInitialProps");

Object.keys(_getInitialProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getInitialProps[key];
    }
  });
});

var _checkIsPassiveSupported = require("./checkIsPassiveSupported");

Object.keys(_checkIsPassiveSupported).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _checkIsPassiveSupported[key];
    }
  });
});

var _calculateDuration = require("./calculateDuration");

Object.keys(_calculateDuration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculateDuration[key];
    }
  });
});

var _calculatePosition = require("./calculatePosition");

Object.keys(_calculatePosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculatePosition[key];
    }
  });
});

var _calculateMovingPosition = require("./calculateMovingPosition");

Object.keys(_calculateMovingPosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculateMovingPosition[key];
    }
  });
});

var _calculateVelocity = require("./calculateVelocity");

Object.keys(_calculateVelocity).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculateVelocity[key];
    }
  });
});

var _rotateByAngle = require("./rotateByAngle");

Object.keys(_rotateByAngle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _rotateByAngle[key];
    }
  });
});

var _checkIsMoreThanSingleTouches = require("./checkIsMoreThanSingleTouches");

Object.keys(_checkIsMoreThanSingleTouches).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _checkIsMoreThanSingleTouches[key];
    }
  });
});

var _createOptions = require("./createOptions");

Object.keys(_createOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createOptions[key];
    }
  });
});

var _getOptions = require("./getOptions");

Object.keys(_getOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getOptions[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/vanilla-swipe/lib/utils/index.js
// module id = 96
// module chunks = 0